import { PageItem } from "@/constants/workbench";
import { Active, Over } from "@dnd-kit/core";

// 判断是否触发合并的条件
export function shouldMergeByDirection(
  active: Active | null,
  over: Over | null,
  activeIndex: number,
  overIndex: number
): boolean {
  if (!active || !over || active.id === over.id) return false;

  const activeRect = active.rect?.current?.translated;
  const overRect = over.rect;

  // 如果没有矩形信息则返回false
  if (!activeRect || !overRect) return false;

  // 计算拖动元素与目标元素的垂直重叠
  const activeTop = activeRect.top;
  const overTop = overRect.top;
  const activeBottom = activeRect.bottom;
  const overBottom = overRect.bottom;

  // console.log(`Active top: ${activeTop}, Over top: ${overTop}`);

  // 如果是activeIndex > overIndex,则代表是从下往上拖动
  // 如果是activeIndex < overIndex,则代表是从上往下拖动
  // 从下往上拖动，判断activeTop是否大于overTop，是的话，则满足合并条件，否则就是排序
  // 从上往下拖动，判断activeTop是否小于overTop，是的话，则满足合并条件，否则就是排序

  if (activeIndex > overIndex && activeTop > overTop) {
    return true;
  }

  if (activeIndex < overIndex && activeTop < overTop) {
    return true;
  }

  return false; // 不满足合并条件
}

// 判断是否可以排序
export function canSortByDirection(
  active: Active | null,
  over: Over | null,
  activeIndex: number,
  overIndex: number
) {
  if (!active || !over || active.id === over.id) return false;

  const activeRect = active.rect?.current?.translated;
  const overRect = over.rect;

  // 如果没有矩形信息则返回false
  if (!activeRect || !overRect) return false;

  // 计算拖动元素与目标元素的垂直重叠
  const activeTop = activeRect.top;
  const overTop = overRect.top;

  // console.log(`Active top: ${activeTop}, Over top: ${overTop}`);

  // 如果是activeIndex > overIndex,则代表是从下往上拖动
  // 如果是activeIndex < overIndex,则代表是从上往下拖动
  // 从下往上拖动，判断activeTop是否大于overTop，是的话，则满足合并条件，否则就是排序
  // 从上往下拖动，判断activeTop是否小于overTop，是的话，则满足合并条件，否则就是排序

  if (activeIndex > overIndex && activeTop < overTop) {
    return true;
  }

  if (activeIndex < overIndex && activeTop > overTop) {
    return true;
  }

  return false; // 不满足合并条件
}

export function getPageItemById(items: PageItem[], id: string) {
  return items.find((item) => item.id === id);
}

export function getPageItemIndexById(items: PageItem[], id: string) {
  return items.findIndex((item) => item.id === id);
}
